/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { buildRequiredSchema } from 'utils';
import {
  DialogDefaultV2,
  InputV2,
  NumberInputV2,
  OptionSelectV2,
} from '../../../../components/v2';

const defaultValue = {
  tipoCompraNota: 'PECAS_MANUTENCAO_VEICULAR',
};

const PecasFormulario = ({ open, onClose, onSave, selectedPeca }) => {
  const [values, setValues] = useState(defaultValue);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedPeca) {
      setValues(selectedPeca);
    } else {
      setValues(defaultValue);
    }
  }, [selectedPeca]);

  const onCloseLocal = () => {
    setErrors({});
    setValues(defaultValue);
    onClose();
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const onSaveLocal = () => {
    const erros = validate(values, buildRequiredSchema(['tipoCompraOptionId', 'valor', 'quantidade']));
    setErrors(erros || {});
    if (!erros) {
      let data = values;
      if (!data.id) {
        data = { ...data, id: uuidv4() };
      }
      onSave(data);
      setValues(defaultValue);
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCloseLocal}
      handlerConfirm={onSaveLocal}
      title="Peça"
      confirmMessage={selectedPeca ? 'Atualizar' : 'Adicionar'}
      maxWidth="md"
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <OptionSelectV2
            label="Peça"
            codigo="NOTA_COMPRAS_PECAS"
            isRequired
            onSelect={(tipoCompraOptionId, tipoCompraOptionNome) =>
              setValues({ ...values, tipoCompraOptionId, tipoCompraOptionNome })
            }
            value={values.tipoCompraOptionId}
            error={!!(errors && errors.tipoCompraOptionId)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <NumberInputV2
            error={!!(errors && errors.valor)}
            isRequired
            label="Valor"
            prefix="R$ "
            onChange={(valor) => setValues({ ...values, valor })}
            value={values.valor}
            decimalScale={2}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Quantidade"
            name="quantidade"
            onChange={handleChange}
            value={values.quantidade || ''}
            error={!!(errors && errors.quantidade)}
            isRequired
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao || ''}
            rows={2}
            multiline
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

PecasFormulario.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  selectedPeca: PropTypes.object,
};

PecasFormulario.defaultProps = {
  selectedPeca: null,
};

export default PecasFormulario;
